export const fromCurrentYearOn = (numYears = 20) => {
  const currentYear = new Date().getFullYear();
  return Array.from({ length: numYears }, (_, i) => currentYear + i);
};
